import INTELLIPAAT from "../../../assets/images/Intellipaat.png";
import PLANET from "../../../assets/images/planetspark.png";
import arvind from "../../../assets/images/ARVINDFASHIONS.png";
import avatar01 from "../../../assets/images/LG_Software.jpg";
import avatar02 from "../../../assets/images/piinfocomm.jpg";
import bajaj from "../../../assets/images/BAJAJFINANCE.png";
import defaultLogo from "../../../assets/images/logodemo.jpeg";
import seventyfive from "../../../assets/images/75WAYTECHNOLOGIES.jpg";

// export const arr = [
//   {
//     date: "17th March 2023",
//     heading: "ONLINE CAMPUS RECRUITMENT DRIVE BY PIE INFOCOMM",
//     eligibility: "B. Tech. CSE, ME,CE & ECE students (2023 batch)",
//     designation: ` Post according branch*
//           *CS/IT* -JR. SOFTWARE DEVELOPER
//           *EC/EN*- JR. AUTOMATION ENGINEER
//           *CIVIL/MECHANICAL*- AUTOCAD DESIGNER`,
//     Package: `₹ 4,50,000 is for B.Tech and ₹ 5,50,000 is for MBAMCA
//                 Package for Diploma Engineering 3,50,00/-rs3.6 LPA - 1st Year & 4.6 LPA - 2nd Year`,
//     image: avatar02,
//   },
//   {
//     date: "April 17 2023",
//     heading: "CAMPUS RECRUITMENT DRIVE BY OM CAREERS",
//     eligibility: "MBA",
//     designation: "MANAGEMENT TRAINEE",
//     Package: "5.24 LPA- 5.60 LPA",
//     image: defaultLogo,
//   },
//   {
//     date: "APRIL MONTH 2023",
//     heading: "CAMPUS RECRUITMENT DRIVE BY VENTURE PACT",
//     eligibility: "BE/B.TECH/M.TECH/M.SC IT",
//     designation: "SOFTWARE DEVELOPMENT",
//     Package: "4 LPA - 6 LPA",
//     image: defaultLogo,
//   },
//   {
//     date: "APRIL MONTH 2023",
//     heading: "CAMPUS RECRUITMENT DRIVE BY 75WAY TECHNOLOGIES PVT. LTD",
//     eligibility: "B. Tech. - CSE/MCA/MBA",
//     designation: "SOFTWARE DEVELOPMENT EXECUTIVE/BDE/QA ENGINEER",
//     Package: "3 LPA TO 6 LPA",
//     image: defaultLogo,
//   },
//   {
//     date: "April 2022",
//     heading: "Online Campus Recruitment Drive By LG",
//     eligibility:
//       "B.E/B.Tech Computer Science/IT/ECE stream and only 2022 Pass out 60% Throughout",
//     designation: "Developer",
//     location: "Bangalore Hybrid model",
//     lastDate: "26th April 2022 3:00 PM",
//     onlineAssessment: "29th April 2022 Time : 11 AM to 2 PM",
//     Package: "6 LPA",
//     image: avatar01,
//   },
// ];

export const arr = [
  // New Entries for 2025-26
  {
    date: "2025-26",
    heading: "CAMPUS RECRUITMENT DRIVE BY 75WAY TECHNOLOGIES PVT. LTD",
    companyName: "75way Technologies PVT. LTD.",
    officialWebsite: "https://75way.com/",
    eligibility: "B.Tech(CSE/ IT), MCA",
    designation: "Software Developer Executive",
    location: "Mohali",
    expectedJoining: "IMMEDIATE",
    Package: `PACKAGE FOR ASSOCIATE SOFTWARE DEVELOPMENT
Stipend: 12.5K (During first 6 months of the Internship Period)
Basic CTC: 3.60 LPA

PACKAGE FOR SOFTWARE DEVELOPMENT 
Stipend: 15K (During first 6 months of the Internship Period)
CTC: 5.00 LPA`,
    interviewProcess: `1. Telephonic Interview
2. Online Test
3. HR Round`,
    image: seventyfive,
  },
  {
    date: "2025-26",
    heading: "CAMPUS RECRUITMENT DRIVE BY ARVIND FASHION",
    companyName: "Arvind Fashion",
    eligibility: "BBA/BCOM/MBA",
    designation: "Management Trainee",
    location: "PAN INDIA",
    Package: "5 LPA CTC",
    interviewProcess: `1. Group Discussion Round
2. Personal Interview`,
    image: arvind,
  },
  {
    date: "2025-26",
    heading: "CAMPUS RECRUITMENT DRIVE BY BAJAJ FINANCE",
    companyName: "Bajaj Finance",
    eligibility: "MBA/Post Graduate Degree",
    designation: "Deputy Managers",
    location: "PAN India",
    Package: `Metro Locations:
- Fixed: ₹450,000
- Total CTC: ₹568,994

Non-Metro Locations:
- Fixed: ₹390,000
- Total CTC: ₹493,128`,
    interviewProcess: `1. Online Test
2. Telephonic Interview`,
    image: bajaj,
  },
  {
    date: "2025-26",
    heading: "CAMPUS RECRUITMENT DRIVE BY INTELLIPAAT",
    companyName: "Intellipaat",
    eligibility: "BBA/BCOM/MBA",
    designation: "Business Development Associate (Work from Office)",
    location: "Bangalore",
    Package: `Fixed Pay for first 6 months: ₹25,000 per month
After 6 Months of training: Final CTC: ₹9 LPA`,
    interviewProcess: `1. Group Discussion Round
2. Two Rounds of Personal Interview`,
    image: INTELLIPAAT,
  },
  {
    date: "2025-26",
    heading: "CAMPUS RECRUITMENT DRIVE BY PLANET SPARK",
    companyName: "Planet Spark",
    eligibility: "BBA, B.COM & MBA",
    designation: "Business Counsellor",
    location: "Gurugram",
    Package: "6.5 LPA / 7.1 LPA",
    interviewProcess: `1. Online Test
2. Telephonic Interview
3. HR Round`,
    image: PLANET,
  },

  // Older Entries
  {
    date: "17th March 2023",
    heading: "ONLINE CAMPUS RECRUITMENT DRIVE BY PIE INFOCOMM",
    eligibility: "B. Tech. CSE, ME,CE & ECE students (2023 batch)",
    designation: ` Post according branch*
          *CS/IT* -JR. SOFTWARE DEVELOPER
          *EC/EN*- JR. AUTOMATION ENGINEER
          *CIVIL/MECHANICAL*- AUTOCAD DESIGNER`,
    Package: `₹ 4,50,000 is for B.Tech and ₹ 5,50,000 is for MBAMCA
                Package for Diploma Engineering 3,50,00/-rs3.6 LPA - 1st Year & 4.6 LPA - 2nd Year`,
    image: avatar02,
  },
  {
    date: "April 17 2023",
    heading: "CAMPUS RECRUITMENT DRIVE BY OM CAREERS",
    eligibility: "MBA",
    designation: "MANAGEMENT TRAINEE",
    Package: "5.24 LPA- 5.60 LPA",
    image: defaultLogo,
  },

  {
    date: "APRIL MONTH 2023",
    heading: "CAMPUS RECRUITMENT DRIVE BY 75WAY TECHNOLOGIES PVT. LTD",
    eligibility: "B. Tech. - CSE/MCA/MBA",
    designation: "SOFTWARE DEVELOPMENT EXECUTIVE/BDE/QA ENGINEER",
    Package: "3 LPA TO 6 LPA",
    image: defaultLogo,
  },
  {
    date: "April 2022",
    heading: "Online Campus Recruitment Drive By LG",
    eligibility:
      "B.E/B.Tech Computer Science/IT/ECE stream and only 2022 Pass out 60% Throughout",
    designation: "Developer",
    location: "Bangalore Hybrid model",
    lastDate: "26th April 2022 3:00 PM",
    onlineAssessment: "29th April 2022 Time : 11 AM to 2 PM",
    Package: "6 LPA",
    image: avatar01,
  },
  {
    date: "APRIL MONTH 2023",
    heading: "CAMPUS RECRUITMENT DRIVE BY VENTURE PACT",
    eligibility: "BE/B.TECH/M.TECH/M.SC IT",
    designation: "SOFTWARE DEVELOPMENT",
    Package: "4 LPA - 6 LPA",
    image: defaultLogo,
  },
];
